import { useCallback } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useLocalization } from "@fluent/react";
import { ContentCard } from "@narmi/design_system";
import { Dialog, Drawer, NotificationContextProvider } from "cerulean";
import Organization from "byzantine/src/Organization";
import AddressEditDialogBody from "./Address/AddressEditDialog";
import PhoneNumberEditDialogBody from "./ContactInfoCard/PhoneNumberEditDialog";
import EmailEditDialogBody from "./ContactInfoCard/EmailEditDialog";
import UsernameEditDialogBody from "./ContactInfoCard/UsernameEditDialog";
import { getEditDialogType } from "./useIsProfileEditDialogOpen";
import { SudoProvider } from "../../../SudoContext";
import SudoDialog from "../../../SudoDialog";

interface EditDialogProps {
  isOpen: boolean;
  closeDialog: () => void;
  organization?: Organization;
  setOrganization: (organization: Organization) => void;
}

const EditDialog = ({
  isOpen,
  closeDialog,
  organization,
  setOrganization,
}: EditDialogProps) => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  const onClose = useCallback(() => navigate("/profile"), []);
  const dialogType = getEditDialogType();

  return (
    <SudoProvider basename="profile">
      <NotificationContextProvider isPortaled={false}>
        <Drawer
          isOpen={isOpen && dialogType === "address"}
          onUserDismiss={closeDialog}
          depth="545px"
          paddingSize="l"
          showControls={false}
        >
          <h2 style={{ paddingBottom: "20px" }}>
            {l10n.getString("address-edit-dialog-title")}
          </h2>

          <ContentCard paddingSize="m" kind="bordered">
            <AddressEditDialogBody
              closeDialog={closeDialog}
              organization={organization}
              setOrganization={setOrganization}
            />
          </ContentCard>
        </Drawer>
      </NotificationContextProvider>
      {dialogType !== "address" && (
        <Dialog
          isOpen={isOpen}
          onUserDismiss={closeDialog}
          title={l10n.getString(`${dialogType}-edit-dialog-title`)}
        >
          <div className="margin--top--s" />
          <Routes>
            <Route
              path="/email"
              element={<EmailEditDialogBody closeDialog={onClose} />}
            />
            <Route
              path="/phone"
              element={<PhoneNumberEditDialogBody closeDialog={onClose} />}
            />
            <Route
              path="/username"
              element={<UsernameEditDialogBody closeDialog={onClose} />}
            />
          </Routes>
        </Dialog>
      )}
      <SudoDialog />
    </SudoProvider>
  );
};

export default EditDialog;
